import React from 'react';

import { Flex } from '@chakra-ui/react';
import { Avatar, AvatarImage } from '@mesh.ai/rabbit';
import { ICellRendererParams } from 'ag-grid-community';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { Row } from '../MyCompetencies/types/myCompetencies';

export const EmployeeRenderer = ({ data }: ICellRendererParams<Row>) => {
  if (data.competency.value) {
    return <TextBodyMedium ml={2}>{data.competency.value}</TextBodyMedium>;
  }

  return (
    <Flex alignItems="center">
      <Avatar>
        <AvatarImage src={data.employee.value.profilePhoto} />
      </Avatar>
      <TextBodyMedium ml={2}>{data.employee.value.displayName}</TextBodyMedium>
    </Flex>
  );
};
